<template>
  <div id="tags-view-container" class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper">
      <router-link
        v-for="tag in visitedViews"
        ref="tag"
        :key="tag.path"
        :class="isActive(tag) ? 'active' : ''"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
        tag="span"
        class="tags-view-item"
        @click.middle.native="!isAffix(tag) ? closeSelectedTag(tag) : ''"
        @contextmenu.prevent.native="openMenu(tag, $event)">
        {{ tag.title }}
        <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
      </router-link>
    </scroll-pane>
    <ul v-show="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">刷新</li>
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">關閉</li>
      <li @click="closeOthersTags">關閉其他</li>
      <li v-if="!isAffix(selectedTag)" @click="closeAllTags(selectedTag)">關閉全部</li>
    </ul>
  </div>
</template>

<script>
import ScrollPane from './ScrollPane'
import path from 'path'

export default {
  components: { ScrollPane },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: []
    }
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    routes() {
      return this.$store.state.permission.routes
    }
  },
  watch: {
    $route() {
      this.addTags()
      this.moveToCurrentTag()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted() {
    this.initTags()
    this.addTags()
  },
  methods: {
    isActive(route) {
      // 標準化 path，移除尾隨斜線進行比較
      const normalizePath = (path) => {
        if (!path) return ''
        return path.replace(/\/$/, '') || '/'
      }
      const routePath = normalizePath(route.path)
      const currentPath = normalizePath(this.$route.path)
      return routePath === currentPath
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = []
      routes.forEach((route) => {
        // 構建當前路由的完整路徑
        // 如果 route.path 是空字符串，直接使用 basePath；否則使用 path.resolve
        const tagPath = route.path ? path.resolve(basePath, route.path) : basePath

        if (route.meta && route.meta.affix) {
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          })
        }
        // 遞歸處理 children，使用已解析的完整路徑作為 basePath
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, tagPath)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    initTags() {
      const affixTags = (this.affixTags = this.filterAffixTags(this.routes))
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag)
        }
      }
    },
    addTags() {
      const { name } = this.$route
      if (name) {
        // 如果當前路由是 affix，且已經在 initTags 中添加過，則跳過
        // 避免重複添加（雖然 ADD_VISITED_VIEW 有 path 檢查，但這裡提前檢查更安全）
        const isAffix = this.$route.meta && this.$route.meta.affix
        if (isAffix) {
          // 檢查是否已經存在（通過 affixTags 或 visitedViews）
          const exists =
            this.affixTags.some((tag) => tag.path === this.$route.path) ||
            this.$store.state.tagsView.visitedViews.some((v) => v.path === this.$route.path)
          if (exists) {
            return false
          }
        }
        this.$store.dispatch('tagsView/addView', this.$route)
      }
      return false
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag)
            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch('tagsView/updateVisitedView', this.$route)
            }
            break
          }
        }
      })
    },
    refreshSelectedTag(view) {
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath
          })
        })
      })
    },
    closeSelectedTag(view) {
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag)
      this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    closeAllTags(view) {
      this.$router.push('/')
      this.$store.dispatch('tagsView/delAllViews', '/').then(({ visitedViews }) => {
        if (this.affixTags.some((tag) => tag.path === view.path)) {
          return
        }
        this.toLastView(visitedViews, view)
      })
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.fullPath)
      } else {
        // 如果沒有其他標籤，重定向到默認頁面（簽署任務管理）
        this.$router.push('/')
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }

      this.top = e.clientY
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.tags-view-container {
  height: 48px;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  overflow: hidden;
  .tags-view-wrapper {
    height: 100%;
    display: flex;
    align-items: center;

    .tags-view-item {
      display: inline-flex;
      align-items: center;
      position: relative;
      cursor: pointer;
      height: 32px;
      border: 1px solid #d8dce5;
      color: #495060;
      background: #fff;
      padding: 0 12px 0 14px;
      font-size: 14px;
      border-radius: 6px;
      margin-left: 6px;
      transition: all 0.2s ease;
      &:first-of-type {
        margin-left: 15px;
      }
      &:last-of-type {
        margin-right: 15px;
      }
      &:hover {
        border-color: #42b983;
        color: #42b983;
      }
      &.active {
        background-color: #42b983;
        color: #fff;
        border-color: #42b983;
        font-weight: 500;
        box-shadow: 0 2px 4px rgba(66, 185, 131, 0.2);
      }
    }
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.15);
    li {
      margin: 0;
      padding: 8px 18px;
      cursor: pointer;
      transition: background-color 0.2s ease;
      &:hover {
        background: #f5f7fa;
      }
    }
  }
}
</style>

<style lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      margin-left: 8px;
      margin-right: -2px;
      transition: all 0.2s ease;
      flex-shrink: 0;
      &:before {
        font-size: 15px;
        line-height: 1;
      }
      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
        color: #fff;
      }
    }
    &.active .el-icon-close {
      &:hover {
        background-color: rgba(255, 255, 255, 0.25);
      }
    }
  }
}
</style>
